import { Box, IconButton, Typography } from "@mui/material";
import React,{useEffect,useState} from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { useDispatch, useSelector } from "react-redux";
//import { catchElement, elementToBase64 } from "../reviewUtils";
import { exportFile_ReviewOrderQuota, exportFile_ReviewOrderQuotaandConsumption } from "../reviewSlice";
import { transform } from "lodash";
import { Translate } from "@mui/icons-material";

const ExportIcons = (props) => {
  const isQuotaConsumption = props.isQuotaConsumption;
  const dispatch = useDispatch();
  const state = useSelector((store) => store.review);
  const [currentWeek, setCurrentWeek] = useState(0);
  const {
    selectedPeriod,
    getScenarios,
    selectedCountry,
    selectedOrderStatus,
    OrderStatus,
    selectedCountryID,
    getQuotaDetails,
    selectedScenario,
    getWeekStatus
  } = state;

  const CriticalityMap = {
    1: "Low",
    2: "Medium",
    3: "High",
    4: "Severe",
  };

  const PeriodMap = {
    0: "Previous",
    1: "Current",
  };

  useEffect(() => {
    if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
      setCurrentWeek(1);
    } else if (getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly") {
      if (getWeekStatus.chkFirstHalf == true) {
        setCurrentWeek(1);
      } else if (getWeekStatus.chkSecondHalf == true) {
        setCurrentWeek(2);
      }
    } else {
      if (getWeekStatus.chkMonth == true) {
        if (getWeekStatus.chkWeek1 == true) {
          setCurrentWeek(1);
        } else if (getWeekStatus.chkWeek2 == true) {
          setCurrentWeek(2);
        } else if (getWeekStatus.chkWeek3 == true) {
          setCurrentWeek(3);
        } else if (getWeekStatus.chkWeek4 == true) {
          setCurrentWeek(4);
        } else if (getWeekStatus.chkWeek5 == true) {
          setCurrentWeek(5);
        }
      } else {
        setCurrentWeek(0);
      }
    }
  }, [getWeekStatus]); 

  async function exportDataAsFile(isPdf) {
    debugger;

    if(isQuotaConsumption){
      let exportlst = [];
      if(getQuotaDetails?.depletionModel?.toLowerCase() === "none"){
        exportlst = getQuotaDetails?.quotaCusumptionCustomers.map((item) => {

          let availableQuota = 0;
          if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
            availableQuota = item.weekly1 - item.consumption;
          } else if (getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly") {
            if (currentWeek === 1) {
              availableQuota = item.weekly1 - item.consumption;
            } else {
              availableQuota = item.weekly2 - item.consumption;
            }
          } else {
            if (currentWeek === 1) {
              availableQuota = item.weekly1 - item.consumption;
            } else if (currentWeek === 2) {
              availableQuota = item.weekly2 - item.consumption;
            } else if (currentWeek === 3) {
              availableQuota = item.weekly3 - item.consumption;
            } else if (currentWeek === 4) {
              availableQuota = item.weekly4 - item.consumption;
            } else {
              availableQuota = item.weekly5 - item.consumption;
            }
          }
return{
        ['Customer / CG']: item.customerName,
        CustomerNumber: item.sapCustomerNumber,
        ['SKU / PG']: item.skuName,
        SKUNumber: item.skuNumb,
        CustomerType : item.customerType,
        CustomerTrustLevel: item.customerTrustLevel,
        OrderStatus: item.orderStatus,
        ['UnusedQuota - PreviousPeriod']: item.unusedQuota,
        Quota: item.quota,
        Consumption: item.consumption,
        AvailableQuota : availableQuota,
        IntendedQuantity : item.intendedQuantity,
        ModifiedQuantity : item.modifiedOrderQtyUoM,
        FinalQuota : item.weekly1,
        TodaysConsumption : item.todaysConsumption,
        YesterdaysConsumption : item.yesterdaysConsumption,
        ATSTQ : item.stickToQuota,
        Comments : item.customerComments
}
      });
    }else{
      exportlst = getQuotaDetails?.quotaCusumptionCustomers.map((item) => {
        let availableQuota = 0;
        if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
          availableQuota = item.weekly1 - item.consumption;
        } else if (getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly") {
          if (currentWeek === 1) {
            availableQuota = item.weekly1 - item.consumption;
          } else {
            availableQuota = item.weekly2 - item.consumption;
          }
        } else {
          if (currentWeek === 1) {
            availableQuota = item.weekly1 - item.consumption;
          } else if (currentWeek === 2) {
            availableQuota = item.weekly2 - item.consumption;
          } else if (currentWeek === 3) {
            availableQuota = item.weekly3 - item.consumption;
          } else if (currentWeek === 4) {
            availableQuota = item.weekly4 - item.consumption;
          } else {
            availableQuota = item.weekly5 - item.consumption;
          }
        }
return{
        ['Customer / CG']: item.customerName,
        CustomerNumber: item.sapCustomerNumber,
        ['SKU / PG']: item.skuName,
        SKUNumber: item.skuNumb,
        CustomerType : item.customerType,
        CustomerTrustLevel: item.customerTrustLevel,
        OrderStatus: item.orderStatus,
        ['UnusedQuota - PreviousPeriod']: item.unusedQuota,
        Quota: item.quota,
        Consumption: item.consumption,
        AvailableQuota : availableQuota,
        IntendedQuantity : item.intendedQuantity,
        ModifiedQuantity : item.modifiedOrderQtyUoM,
        Week1 : item.weekly1,
        Week2 : item.weekly2,
        Week3 : item.weekly3,
        Week4 : item.weekly4,
        Week5 : item.weekly5,
        TodaysConsumption : item.todaysConsumption,
        YesterdaysConsumption : item.yesterdaysConsumption,
        ATSTQ : item.stickToQuota,
        Comments : item.customerComments
}
      });
    }
      let postData = {
        isPdf,
        ReviewTitle: `ReviewOrder and Consumption ${selectedScenario} Data`,
        CountryName: getQuotaDetails.geoName,
        Period: PeriodMap[selectedPeriod],
        Scenario: selectedScenario,
        listReviewOrdrQuotaConsumptionData: exportlst,
      };
      dispatch(exportFile_ReviewOrderQuotaandConsumption(postData));
    }else{
      const exportlist = getScenarios.map((item) => ({
        Scenario: item.scenarioName,
        Country: item.geoCode,
        Criticality: CriticalityMap[item.criticalityId],
        orderStatus: item.orderStatus,
        Quota: item.quota,
        //EFS: item.efs,
        ActualConsumption: item.consumption,
        TodaysConsumption: item.todaysConsumption,
        YesterdaysConsumption: item.yesterdaysConsumption,
        NoOfBlockedCustomers: item.noOfBlockedCustomers,
        IntendedQuantity: item.intendedQuantity,
        SAPDate: item.sapRefresh.toString().indexOf('0001') >= 0 ? "" : formarDate(item.sapRefresh),
      }));
      let postData = {
        isPdf,
        ReviewTitle: `ReviewOrder ${selectedCountry} Data`,
        CountryID: selectedCountryID,
        CountryName: selectedCountry,
        Period: PeriodMap[selectedPeriod],
        OrderStatus: selectedOrderStatus,
        listReviewOrdrData: exportlist,
      };
      console.log("exportlist", exportlist);
      dispatch(exportFile_ReviewOrderQuota(postData));
    }
  }

  function formarDate(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    //return '${day}/${month}/${year}';
    return `${day}/${month}/${year}`;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        marginLeft: "calc(100% - 100px)",
      }}
    >
      <IconButton onClick={(e) => exportDataAsFile(false)}>
        <GridOnIcon sx={{ color: "green.main" }} />
      </IconButton>
      {/* <IconButton onClick={(e) => exportDataAsFile(true)}>
        <PictureAsPdfIcon sx={{ color: "red.main" }} />
      </IconButton> */}
    </Box>
  );
}
export default ExportIcons;